import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { showModal, hideModal } from 'appSrc/redux/actions';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import EditModal from '../../Modals/Videos/EditModal';
import { InternalLink, PrimaryButton, DLRichTextOutput } from 'appSrc/components/UI';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import NewReviewModal from '../../Modals/Review/NewReviewModal';
import Table from './TranscriptsTable';
import style from './styles/style.module.css';

class IndividualItemPage extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            fetching: true,
            item: {},
            showNewReviewModal: false,
        };
        this.loadItem( this.props.match.params.id );
    }

    loadItem = ( itemId ) => {
        this.props.getItem( itemId )
        .then( ( item ) => {
            this.setState( {
                fetching: false,
                item: item,
            } );
        } );
    }

    openEditModal = () => {
        this.props.showModal( 'editProductModal' );
    }

    onEditSubmit = ( updates ) => {
        var oldProduct = this.state.item;
        var calls = [];
        return this.props.updateItem( oldProduct.id, updates )
        .then( ( updatedItem ) => {
            this.setState( { item: updatedItem } );
            return updatedItem;
        } );
    }

    onEditClose = () => {
        this.props.hideModal( 'editProductModal' );
    }


    render() {
        const { fetching, item } = this.state;

        if( fetching ) {
            return (
                <section className={ style.individual }>
                    <LoadingReplace />
                </section>
            );
        }

        const authors = item.authors || [];

        return (
            <section className={ style.individual }>
                <div className={ style.head }>
                    <div className={ style.controls }>
                        <div className={ style.backLink } onClick={ this.props.history.goBack }>Back</div>
                        <div>
                            <PrimaryButton label='Edit Video' onClick={ this.openEditModal } />
                        </div>
                    </div>
                    <div className={ style.individualDetails }>
                        <ListCoverImage coverImage={ item.coverImage } videoId={ item.youtubeId } />
                        <div>
                            <div className={ style.title }>
                                <h2 style={ { marginRight: '15px' } }>{ item.title }</h2>
                            </div>
                            <div className={ style.author }>
                                <p>Created by:
                                    { authors.map( ( user ) => ( 
                                        <span key={ user.userid }>&#32;<InternalLink to={ `/admin/users/${ user.userid }` }>{ user.displayName }</InternalLink></span>
                                    ) ) }
                                </p>
                            </div>
                            <div className={ style.description }>
                                <DLRichTextOutput content={ item.description } />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={ style.body }>
                    <Table transcripts={ item.transcripts } />
                </div>
                <EditModal closeModal={ this.onEditClose }
                onSubmit={ this.onEditSubmit }
                item={ item } />
                { this.state.showNewReviewModal &&
                    <NewReviewModal closeModal={ this.onNewReviewClose }
                    onSubmit={ this.onNewReviewSubmit }
                    item={ item }/>
                }
            </section>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        getItem: ( itemId ) => {
            return dAPI.get( `/admin/videos/${ itemId }` );
        },
        updateItem: ( itemId, data ) => {
            return dAPI.patch( `/admin/videos/${ itemId }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( IndividualItemPage );
